import { render, staticRenderFns } from "./change-primary-owner.vue?vue&type=template&id=69905d07&"
import script from "./change-primary-owner.vue?vue&type=script&lang=ts&"
export * from "./change-primary-owner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports